import { render, staticRenderFns } from "./ContentTypeDurationInput.vue?vue&type=template&id=4020a930&"
import script from "./ContentTypeDurationInput.vue?vue&type=script&lang=ts&"
export * from "./ContentTypeDurationInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports